module.exports = __webpack_public_path__ + "cancellara-dist/img/aon-info.4183d033.png";